import { Globe, Smartphone, Bot } from "lucide-react";

const PILLARS = [
  {
    icon: Globe,
    kicker: "01 · Build",
    title: "Website Development",
    desc: "Fast, SEO-first, conversion-tuned websites — from D2C storefronts to booking-driven service sites.",
    points: ["Next-gen design + CMS", "SEO & Core Web Vitals", "Payments & bookings"],
  },
  {
    icon: Smartphone,
    kicker: "02 · Build",
    title: "App Development",
    desc: "Native-feel iOS & Android apps and PWAs, shipped fast with clean, scalable architecture.",
    points: ["iOS + Android", "APIs & dashboards", "Play Store / App Store"],
  },
  {
    icon: Bot,
    kicker: "03 · Automate",
    title: "AI Agents & Automation",
    desc: "AI humans and workflow automation for support, sales, voice, outreach and back-office ops.",
    points: ["Multilingual AI agents", "Voice & chat automation", "CRM + workflow bots"],
  },
];

export default function Capabilities() {
  return (
    <section id="capabilities" className="relative py-20 sm:py-28" data-testid="capabilities-section">
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8">
        <div className="max-w-[680px] mb-10 sm:mb-14">
          <span className="yg-eyebrow">// What we do</span>
          <h2 className="yg-h2 text-[clamp(30px,4.6vw,52px)] mt-3 text-white">
            One partner for
            <br />
            <span className="text-[var(--yg-violet-light)]">web, apps &amp; AI.</span>
          </h2>
          <p className="mt-4 text-[14.5px] sm:text-[15.5px] text-[var(--yg-text-mute)] max-w-[520px]">
            Yugiq is an AI technology company. We design and build your digital product — then wire it with AI agents and automation so it sells and serves on autopilot.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 sm:gap-5">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                className="yg-card yg-card-hover p-6 sm:p-7 flex flex-col"
                data-testid={`capability-${i}`}
                style={{ animation: `yg-rise 700ms ${i * 100}ms both cubic-bezier(.2,.9,.3,1)` }}
              >
                <div className="flex items-center justify-between">
                  <div
                    className="w-11 h-11 rounded-[12px] flex items-center justify-center"
                    style={{ background: "rgba(139,92,246,0.12)", border: "1px solid rgba(139,92,246,0.30)" }}
                  >
                    <Icon className="w-5 h-5 text-[var(--yg-violet-light)]" strokeWidth={2} />
                  </div>
                  <span className="yg-mono text-[10px] tracking-[0.22em] uppercase text-[var(--yg-text-dim)]">{p.kicker}</span>
                </div>

                <h3 className="mt-5 text-white font-extrabold text-[22px] tracking-[-0.02em] leading-tight">{p.title}</h3>
                <p className="mt-3 text-[14px] leading-relaxed text-[var(--yg-text-mute)]">{p.desc}</p>

                <ul className="mt-5 pt-5 border-t border-[var(--yg-border)] space-y-2.5">
                  {p.points.map((pt) => (
                    <li key={pt} className="flex items-center gap-2.5 text-[13px] text-white/85">
                      <span className="w-1.5 h-1.5 rounded-full bg-[var(--yg-violet-light)] shrink-0" />
                      {pt}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
